module.exports = __webpack_public_path__ + "static/media/turystyka.fb63339c.svg";